import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { DiscountCode, formatPrice, pricingPlans, discountedPrice } from '../../data/pricingPlans';
type PlanStageProps = {
  selectedPlanId: string | null;
  discount?: DiscountCode;
  onSelect: (planId: string) => void;
  onContinue: () => void;
  showError: boolean;
};
export function PlanStage({
  selectedPlanId,
  discount,
  onSelect,
  onContinue,
  showError
}: PlanStageProps) {
  return <div className="mt-7" data-id="element-254" data-mp="2m78npcxwxdgp">
      <fieldset data-id="element-255" data-mp="2i7gnpoml4fmy">
        <legend className="sr-only" data-id="element-256" data-mp="2i6x483hadj6t">Choose your plan</legend>
        <ul className="space-y-3" data-id="element-257" data-mp="2d8vlxkropnwe">
          {pricingPlans.filter(plan => plan.monthlyPrice !== null).map(plan => {
          const isSelected = plan.id === selectedPlanId;
          const applies = discount && discount.planId === plan.id && plan.monthlyPrice !== null;
          const price = applies && plan.monthlyPrice !== null ? discountedPrice(plan.monthlyPrice, discount.percentOff) : plan.monthlyPrice;
          return <li key={plan.id} data-id="element-258" data-mp="255qnn5mzqabu">
                <label className={`flex cursor-pointer gap-3.5 rounded-xl border p-4 transition-colors duration-150 ${isSelected ? 'border-[#041F60] bg-[#A6B6F8]/15' : 'border-[#A6B6F8]/60 bg-white hover:border-[#5B5299]'}`} data-id="element-259" data-mp="251uhmfpc4kmg">
                  <input type="radio" name="plan" value={plan.id} checked={isSelected} onChange={() => onSelect(plan.id)} className="sr-only" data-id="element-260" data-mp="2or4uzn1lythe" />
                  <span aria-hidden="true" className={`mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full border-2 ${isSelected ? 'border-[#041F60] bg-[#041F60] text-white' : 'border-[#A6B6F8]'}`} data-id="element-261" data-mp="32rfoyyy7so6s">
                    {isSelected && <CheckIcon size={12} strokeWidth={3} data-id="element-262" data-mp="37ggmbpsj6rkz" />}
                  </span>

                  <span className="min-w-0 flex-1" data-id="element-263" data-mp="37ibadcz3mzta">
                    <span className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1" data-id="element-264" data-mp="33dtsxkg7oylo">
                      <span className="text-sm font-bold uppercase tracking-[0.06em] text-[#041F60]" data-id="element-265" data-mp="2ygtunvplt054">
                        {plan.name}
                      </span>
                      <span className="text-base font-bold text-[#041F60]" data-id="element-266" data-mp="2opphn1jhnpcx">
                        {formatPrice(price)}
                        {plan.monthlyPrice !== null && <span className="text-xs font-semibold text-stone-500" data-id="element-267" data-mp="2jp1hnqda7y6k">
                            {' '}
                            / mo
                          </span>}
                      </span>
                    </span>
                    <span className="mt-1 block text-sm leading-6 text-[#3A3A3A]" data-id="element-268" data-mp="q7dq78fefplq">
                      {plan.tagline}
                    </span>
                    {applies && <span className="mt-2 flex flex-wrap items-baseline gap-2" data-id="element-269" data-mp="z9wodf88pe1n">
                        <span className="rounded-full bg-[#4BE4FF] px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.08em] text-[#041F60]" data-id="element-270" data-mp="148gb3hunqtv2">
                          {discount.label} {discount.percentOff}% off
                        </span>
                        <span className="text-xs text-stone-500 line-through" data-id="element-271" data-mp="bjisteqg4x2b">
                          {formatPrice(plan.monthlyPrice)}
                        </span>
                      </span>}
                    {plan.recommended && !applies && <span className="mt-2 block text-xs font-bold text-[#5B5299]" data-id="element-272" data-mp="3jyaynq7obo26">
                        Most popular
                      </span>}
                  </span>
                </label>
                </li>;
        })}
        </ul>
      </fieldset>

      {showError && <p role="alert" className="mt-4 text-sm font-semibold text-rose-600" data-id="element-273" data-mp="1qi6n2xrjboil">
          Choose a plan to continue.
        </p>}

      <button type="button" onClick={onContinue} className="mt-7 flex w-full items-center justify-center gap-2 rounded-lg bg-[#041F60] px-4 py-3.5 text-sm font-bold text-white transition-colors duration-150 hover:bg-[#031849] focus:outline-none focus:ring-2 focus:ring-[#4BE4FF] focus:ring-offset-2" data-id="element-274" data-mp="1zh1pdyrgkegm">
        Continue <ArrowRightIcon size={17} aria-hidden="true" data-id="element-275" data-mp="2n5b9mw90wu5n" />
      </button>

      <p className="mt-4 text-xs leading-5 text-stone-500" data-id="element-276" data-mp="2j4hm43zhthda">
        Your plan starts after the free trial. You can change plan at any time
        by contacting support.
      </p>
    </div>;
}